import { fromJS, List, Map } from 'immutable';

export function request(state, { data }) {
    return state.set('state', 'IN_PROGRESS');
}

export function finish(state, { data }) {
    return state.set('state', 'FINISHED')
        .setIn([ 'items', data.id ], fromJS(data));
}

export function error(state, { errors }) {
    return state.set('state', 'ERROR');
}
